<template>

    <section id="form-show">

      <div class="box is-shadowless">

        <b-loading :is-full-page="false" :active.sync="routeLoading"></b-loading>

        <div v-if="form.id && ! routeLoading">

          <div class="is-pulled-right">

            <span class="tag is-large" :class="getStatusTagClasses(form.status)">{{ form.status }}</span>

          </div>

          <h1 class="title is-3">Inspection {{ form.id }}</h1>

          <table class="table" style="width: 100%;">

            <tbody>

              <tr>
                <td style="width: 30%;">Form Type</td>
                <td>{{form.type.text}}</td>
              </tr>

              <tr>
                <td>Inspected By</td>
                <td>{{ dForm.inspector ? `${dForm.inspector.firstName} ${dForm.inspector.lastName}` : '' }}</td>
              </tr>

              <tr>
                <td style="width: 30%;">Start Date/Time</td>
                <td>{{ form.start_datetime  | toLocalDateAndTime }}</td>
              </tr>

              <tr>
                <td style="width: 30%;">Work Order</td>
                <td><a v-if="dForm.order" :href="`/orders?orderId=${dForm.order.id}`">{{ dForm.order.orderId }}</a></td>
              </tr>

              <tr>
                <td>Asset Class</td>
                <td>
                  {{ getSelectedValues(form.asset_class, assetClasses).join(', ') || '' }}
                </td>
              </tr>

              <tr>
                <td>Asset ID</td>
                <td>{{ dForm.asset_code || '' }}</td>
              </tr>

              <tr :key="idx" v-for="(criterion, idx) in criteria">

                <td>{{ criterion.field_label }}</td>

                <td>

                  <div v-if="criterion.input_type === dropdown && criterion.values != 'please_select'">

                    {{ getSelectedValue(criterion.values, criterion.input_type_options) || '' }}

                  </div>

                  <div v-if="criterion.input_type === multidropdown">

                    {{ getSelectedValues(criterion.values, criterion.input_type_options).join(', ') || '' }}

                  </div>

                  <div v-if="criterion.input_type === string || criterion.input_type === text">

                    {{ criterion.values || '' }}

                  </div>

                  <div v-if="criterion.input_type === switch_unix">

                    <span v-if="criterion.values">{{ criterion.values | fromUnix | toLocalDateAndTime }}</span>

                  </div>

                  <div v-if="criterion.input_type === upload">

                    <div class="columns is-multiline is-mobile" v-if="criteriaFiles[idx].length > 0">

                      <div class="column is-half-mobile is-one-fifth-tablet"
                        v-for="(file, id) in criteriaFiles[idx]"
                        :key="id">
                        <a :href="file.full_url"><img :src="file.full_url" alt="Loading..."></a>
                      </div>

                    </div>

                    <span v-if="criteriaFiles[idx].length == 0">No files uploaded</span>

                  </div>

                </td>

              </tr>
              <tr>
                <td>Engineer Required?</td>
                <td>
                  <span v-if="form.engineer_required != undefined">
                    {{ form.engineer_required === 1 ? "Yes" : "No" }}
                  </span>
                </td>
              </tr>
              <tr>
                <td>General Comments</td>
                <td>{{ form.notes }}</td>
              </tr>
              <tr>
                <td>Health and Safety Comments</td>
                <td>{{ form.hs_notes }}</td>
              </tr>
              <tr>
                <td>Finish Date/Time</td>
                <td>{{ form.finish_datetime | toLocalDateAndTime }}</td>
              </tr>
            </tbody>

          </table>

          <!-- START: The comment box and list of comments -->
          <hr>

          <h2 class="is-size-4 has-margin-bottom-1">Comments</h2>

          <div class="columns">

            <div class="column is-one-third-tablet">

              <div class="box has-background-light">

                <form class="form" @submit.prevent="onSubmit">

                  <div class="field">
                    <textarea v-model="comment" class="textarea" id="comment" placeholder="Comment here ..."></textarea>
                  </div>

                  <div class="field">
                      <button class="button is-info" type="submit"><i class="fa fa-check"></i> &nbsp; Submit</button>
                  </div>

                </form>

              </div>

            </div>

            <div class="column">

              <div class="box has-background-light">

                <p class="has-text-grey" v-if="comments.length === 0">No comments found.</p>

                <div v-else>

                  <div class="has-margin-bottom-1" v-for="comment in comments">

                    <div class="content">
                      <p>
                        <small>
                          <strong>{{comment.user.firstName}} {{comment.user.lastName}}</strong> &nbsp;
                          <span class="has-text-grey is-size-6">{{comment.createdAt}}</span>
                        </small>
                        <br>
                        {{comment.content}}
                      </p>
                    </div>

                  </div>

                  <b-pagination
                      :total="total"
                      :current.sync="current"
                      :simple="isSimple"
                      :per-page="perPage"
                      v-on:change="next($event)"
                      >
                  </b-pagination>

                </div>

              </div>

            </div>

          </div>

        </div> <!-- simple wrapper for if a form was found -->

      </div>

    </section>

</template>

<style scoped>
.has-margin-bottom-1 {
  margin-bottom: 1rem;
}
</style>

<script>
import { FormService } from "@/services/form.service.js";
import { CommentTransformer } from "@/helpers/comments/comment.transformer";
import { FormTransformer } from "@/helpers/forms/form.transformer";
import { FormCriteriaTransformer } from "@/helpers/forms/form-criteria.transformer";
import { CriteriaActions } from "@/helpers/forms/form-criteria-actions";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer.js";
import { AssetClass } from "@/helpers/asset-class-options.js";
import * as moment from "moment";
// import _ from 'lodash/lodash';

export default {
  name: "form-show",
  data() {
    return {
      routeLoading: false,
      assetClasses: [],
      form: {
        type: "",
        completed_at: moment().format("MMM. D, YYYY, h:mm A"),
        completed_by: "",
        asset_name: "",
        notes: "",
        file: "",
        status: "draft"
      },
      dForm: {},
      form_id: this.$route.params.id,
      dropdown: CriteriaActions.DROPDOWN,
      multidropdown: CriteriaActions.MULTIDROPDOWN,
      upload: CriteriaActions.UPLOAD,
      text: CriteriaActions.TEXT,
      string: CriteriaActions.STRING,
      switch_unix: CriteriaActions.SWITCH_UNIX,
      criteria: [],
      criteriaFiles: [],
      comment: "",
      comments: [],
      total: "",
      current: "",
      perPage: 100,
      isSimple: false,
      isRounded: false,
      files: [],
      imgUrl: process.env.API_URL + "/uploads/",
      files: [],
      filePath: process.env.API_URL + "/uploads/",
      multidropdownDefault: []
    };
  },
  async mounted() {
    // this.loadForm();
    // this.loadComments();
    // this.loadFormCriteria();
    this.$data.assetClasses = AssetClass.options();
    this.$data.routeLoading = true;
    this.loadFormCriteria();
    await this.loadForm();
    await this.loadComments();
    this.$data.routeLoading = false;
  },
  methods: {
    async loadForm() {
      return FormService.show(this.form_id, {includes: 'inspector,order'}).then(res => {
        this.form = FormTransformer.transform(res.data);
        this.$data.dForm = JsonDenormalizer.denormalize(res);
      });
    },
    async loadFormCriteria() {
      return FormService.listFormCriteria(this.form_id).then(res => {
        this.criteria = FormCriteriaTransformer.transformArray(res.data);

        // We'll keep an array of files mapped to the criteria index
        // (each criteria index will have at least an empty array)
        let data = [];

        this.criteria.forEach((obj, k) => {
          let files = [];

          if (obj.input_type == "upload") {
            if (Array.isArray(obj.values)) {
              obj.values.forEach((form_response, i) => {
                if (Array.isArray(form_response.files))
                  files = files.concat(form_response.files);
              });
            }
          }

          data[k] = files;

          this.criteriaFiles = data;
        });
      });
    },
    onSubmit() {
      FormService.storeComment(this.form_id, {
        content: this.comment,
        user_id: 1 // Adjust when authentication is created
      }).then(res => {
        this.comment = "";
        this.comments.unshift(CommentTransformer.transform(res.data));
      });
    },
    async loadComments() {
      return FormService.listComments(this.form_id).then(res => {
        this.comments = CommentTransformer.transformArray(res.data);
        this.total = res.meta.pagination.total;
        this.current = res.meta.pagination.current_page;
        this.perPage = res.meta.pagination.per_page;
      });
    },
    next(page) {
      FormService.listComments(this.form_id, page).then(res => {
        this.comments = CommentTransformer.transformArray(res.data);
        this.total = res.meta.pagination.total;
        this.current = res.meta.pagination.current_page;
        this.perPage = res.meta.pagination.per_page;
      });
    },
    getStatusTagClasses(form_status) {
      form_status =
        typeof form_status === "string" ? form_status.toUpperCase() : "";

      const classes = {
        "is-success": form_status == "SUBMITTED",
        "is-dark": form_status == "DRAFT",
        "is-warning": form_status == "VOID"
      };

      return classes;
    },
    getSelectedValue(value, options) {
      return this.getSelectedValues(value, options).shift() || '';
    },
    getSelectedValues(values, options) {

      values = typeof values === "string" ? [values] : values;

      let textValues = [];

      if (values) {

        options.forEach(option => {

          if (values.indexOf(option.value) >= 0) textValues.push(option.text);
        });
      }

      return textValues.sort();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Forms/show/index.vue